import React, { useEffect, useRef, useState } from 'react';
import DynamicForm from '../../FormBuilder/DynamicForm';
import FormContainer from '../../FormBuilder/FormContainer';
import ProjectsService from '../../JourneyProfiles/List/JourneyProfileService';
import { useCurrentUserHook } from '../../Authentication/useUserHook';
import useFormSubmitErroHandler from '../../../hooks/useFormSubmitErroHandler';
import FormSubmitAlertMsg from '../../FormBuilder/FormSubmitAlertMsg';

function ProjectsForm(props) {
    let { current: scope } = useRef({ formFn: {} });

    const [isFormRendered, setFormRendered] = useState(false);
    const [post, setPost] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);

    const { currentUser } = useCurrentUserHook();
    const { errorMsg, onError } = useFormSubmitErroHandler(scope.formFn.setLoading);

    const formId = 409;

    useEffect(() => {
        scope.data = {};
        scope.project = {};
        scope.formFn = {
            form_type: 'project',
            editPermission: true
        };

        if (props.editProject?.id) {
            scope.formMode = 'edit-form-submissions';
            getById(props.editProject.id);
        } else {
            scope.formMode = 'create-form-submissions';
            setFormRendered(true);
        }
    }, [props.editProject]);

    const getById = async (id) => {
        if (props.editProject) {
            scope.project = props.editProject;
            scope.data = scope.project.data || {};
            setFormRendered(true);
        }
    };

    const create = async (project) => {
        project.organization_id = currentUser.current_organization_id;
        project.form_id = formId;
        project.journey_type = 'project';

        const { status, data } = await ProjectsService.create(project);
        if (status === 201) {
            if (props.onSubmit) props.onSubmit();
            onSubmitPageRedirect();
        } else {
            onError(data);
        }
    };

    const update = async (project) => {
        project.form_id = formId;
        project.journey_type = 'project';
        const { status, data } = await ProjectsService.update(project);
        if (status === 204) {
            if (props.onSubmit) props.onSubmit();
            onSubmitPageRedirect();
        } else {
            onError(data);
        }
    };

    const onSubmitPageRedirect = () => {
        if (props.isPopupMode) {
            props.toggleModal();
        }
        setIsSubmitted(true);
    };

    if (isFormRendered) {
        return (
            <div id="ct">
                <FormContainer post={post} isPopupMode={props.isPopupMode}>
                    <FormSubmitAlertMsg isSubmitted={isSubmitted} errorMsg={errorMsg} />
                    {!isSubmitted &&
                        <DynamicForm
                            formMode={scope.formMode}
                            formId={formId}
                            form={scope.project}
                            formFn={scope.formFn}
                            onCreate={create}
                            onUpdate={update}
                            data={scope.data}
                            post={post}
                            onCancel={onSubmitPageRedirect}
                            setPost={setPost}
                            isPopupMode={props.isPopupMode}
                        />
                    }
                </FormContainer>
            </div>
        );
    }

    return null;
}

export default ProjectsForm;